exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.selectBox[data-v-5f385571] {\n    width: 50%;\n    padding: 30px 0;\n    align-items: center;\n    margin-left: 20%;\n    display: inline-flex;\n}\n.selectBox .chip[data-v-5f385571] {\n    color:blue;\n}\nbutton[data-v-5f385571] {\n    height: 3.3rem;\n}\n.bold[data-v-5f385571] {\n    font-weight: bold;\n}\n.clickable[data-v-5f385571]:hover {\n    cursor: pointer;\n}\n\n\n\n", ""]);

// exports
